exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saleBanner[data-v-1585a660],.saleBanner__link[data-v-1585a660]{width:100vw}.saleBanner__img[data-v-1585a660]{width:100%;max-width:100%;height:auto;padding:12px;background:#f3f3f3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1585a660","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/SaleBanner.vue
// module id = noMj
// module chunks = 0